import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Header,
  Divider,
  Table,
  label,
  Button,
  Label,
} from "semantic-ui-react";
import { reduxForm, Field, FieldArray } from "redux-form";
import {
  renderTextField,
  renderOptionField,
  amountsAre,
  branding,
} from "../formcomponents";
import axios from "axios";
import { useDispatch } from "react-redux";
import { BaseUrl, BaseUrlInvoice, ImageUrl } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router";
import { userData } from "../store/userData";
import TravelPackDayItnery from "./TravelPackDayItnery";
import Swal from "sweetalert2";
import TourInvoicepdf from "./TourInvoicepdf";
const TravelPackCreateNew = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const disptch = useDispatch();
  const { id, catId } = useParams();
  const [hotelList, setHotelList] = useState([]);
  const [invoiceData, setInvoiceData] = useState();
  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    getHotelList();
    if (id) {
      getTourPackDetails();
    }

    console.log(id, catId);
  }, []);

  const getHotelList = async () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: 568,
      })
      .then((res) => {
        console.log("res", res.data);
        const hotelName = res.data.map((item) => ({
          text: item.categoryName,
          value: item.categoryId,
        }));
        setHotelList(hotelName);
      });
  };

  const getTourPackDetails = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/getTourInvoiceDetails", {
        ssTourInvoiceId: id,
      })
      .then((res) => {
        console.log("accounts/getTourInvoiceDetails", res.data);
        setInvoiceData(res.data);
        initializeData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const initializeData = (prevData) => {
    props.initialize({
      ...prevData,
    });
  };
  const sumbitForm = async (values) => {
    if (id != "null") {
      const postObject = {
        ...values,
      };

      console.log(`Post data`, JSON.stringify(postObject, null, 2));
      await axios
        .post(BaseUrlInvoice + "accounts/editTourInvoice", postObject)
        .then((res) => {
          console.log(`Response data`, JSON.stringify(res.data, null, 2));

          if (res.data.errorCode === 200) {
            Swal.fire({
              icon: "success",
              title: "sccess",
              text: `${id == "null" ? "Created" : "Updated"}`,
            });
            navigate(-1);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      const postObject = {
        ...values,
        categoryId: catId,
      };

      console.log(`Post data`, JSON.stringify(postObject, null, 2));
      await axios
        .post(BaseUrlInvoice + "accounts/createTourInvoice", postObject)
        .then((res) => {
          console.log(`Response data`, JSON.stringify(res.data, null, 2));

          if (res.data.errorCode === 200) {
            Swal.fire({
              icon: "success",
              title: "sccess",
              text: `${id == "null" ? "Created" : "Updated"}`,
            });
            navigate(-1);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleExportInvoice = () => {
    const url = `/export-tour-invoice/${id}`;

    const a4WidthInPixels = 794; // Approximately 8.27in * 96dpi
    const a4HeightInPixels = 1123; // Approximately 11.69in * 96dpi

    const windowFeatures = `height=${a4HeightInPixels},width=${a4WidthInPixels},top=100,left=100`;
    window.open(url, "_blank", windowFeatures);
    // const windowFeatures = "height=600,width=800,top=100,left=100";
    // window.open(url, "_blank", windowFeatures);
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          New Tour Invoice
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Button type="submit" primary onClick={() => goBack()}>
          Go Back
        </Button>
      </Grid.Row>
      {invoiceData && (
        <Button color="purple" onClick={handleExportInvoice}>
          EXPORT INVOICE
        </Button>
      )}
      <br />
      <Divider hidden />
      <Grid.Row>
        <Grid columns="eight">
          <Grid.Row>
            <Grid.Column>
              {" "}
              <Field
                name="invoiceDate"
                label="Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              {" "}
              <Field
                name="invoiceName" //new
                label="Customer Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name="customerContact" //new
                label="Customer Mobile"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              {" "}
              {/* <Field
                name="invoiceNumber"
                label="Invoice"
                type="text"
              
                component={renderTextField}
              /> */}
              <p>
                <b>Invoice Number</b>
              </p>
              <p>
                <b>{invoiceData?.invoiceNumber}</b>
              </p>
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name="driverName"
                label="Driver Name"
                // options={branding}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="driverNumber"
                label="Driver Number"
                // options={branding}
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name="tourOperator"
                label="Tour Operator"
                // options={branding}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="hotelName"
                label="Hotel Name"
                options={hotelList}
                component={renderOptionField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <div>
        <FieldArray
          name="itemList"
          itemCategory="new-invoice"
          component={TravelPackDayItnery}
        />
      </div>
      <>
        <Button
          floated="right"
          positive
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>{" "}
      </>
    </div>
  );
};

export default reduxForm({
  form: "TravelPackCreateNew",
})(TravelPackCreateNew);
